module.exports = __webpack_public_path__ + "files/green.674bc8c8a561428e14d7c5abe10d696f.png";